import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import '../App.css';
import deliveryService from '../network/services/delivery';
import Header from "../components/landing-page/Header";
import models from "../network/models/quick_models";
import DashboardDeliveryQuote from "../components/dashboard/DashboardDeliveryQuote";
import general_helper from "../helpers/general_helper";
import TimelapseItem from "../components/dashboard/TimelapseItem";
import Loader from "react-loaders";
import DeliverySuccessReceipt from "../components/DeliverySuccessReceipt";
import Footer from "../components/landing-page/Footer";


const TrackingPage = () => {
    let {id} = useParams();
    const [delivery, setDelivery] = useState({});
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        deliveryService.tracking(id).then(response => {
            setDelivery(response.data.data);
            setIsLoading(false);
        }).catch(error => {
            setIsLoading(false);
        })
    }, []);

    let deliveryItem = {...models.createDeliveryOrderResponse, ...delivery};

    return (
        <div className="mainWrapper" style={{marginTop: 150}}>
            <div className="container">
                <Header/>
                <div className="row justify-content-center" style={{minHeight: 600}}>
                    {
                        isLoading ? <Loader type="ball-scale-multiple"/> :
                            deliveryItem.complete === "1" ?
                                <DeliverySuccessReceipt deliveryItem={{data: deliveryItem}}/> :
                                <>
                                    <div className="col-11 col-md-5 col-lg-5 col-xl-5">
                                        <ul className="list-unstyled">
                                            <li>
                                                <p>Tracking number</p>
                                            </li>
                                            <li>
                                                <h3>{deliveryItem.tracking_id}</h3>
                                            </li>
                                            <li>
                                                <p className="small-text-grey"> Estimated Time of Arrival (ETA): <span
                                                    className="badge badge-pill badge-primary"> {deliveryItem.quote.duration + " " + deliveryItem.quote.duration_unit}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <div id="timeline-content">
                                                    <ul className="timeline">
                                                        {
                                                            !general_helper.isEmpty(deliveryItem.timelapse) ? deliveryItem.timelapse.map((timelapses, index) => {
                                                                return <TimelapseItem key={index}
                                                                                      data={{
                                                                                          deliveryItem: deliveryItem,
                                                                                          timelapses: timelapses
                                                                                      }}/>
                                                            }) : null
                                                        }
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-11 col-md-4 col-lg-4 col-xl-4">
                                        <DashboardDeliveryQuote change={{current: {deliveryOrder: deliveryItem}}}/>
                                    </div>
                                </>
                    }
                </div>
            </div>
            <Footer/>
        </div>
    )
};

export default TrackingPage;
